import {
  mmWidgetInit,
  tpgWidgetInit,
  smsbWidgetInit,
} from "../../zendeskWidget/widgets";
import { type VendorStrategies } from "./types";

const MMHelpCenterUrl = "https://support.messagemedia.com";
const MMZendeskKey = "a59b7ab5-9dea-4a60-bbbb-8c1d7d400a2a";
const EngageZendeskKey = "d304b65a-d47f-47d9-a432-fa5b58a15fae";
export const getVendorStrategies: VendorStrategies = () => ({
  mm: {
    brandCode: "mm",
    logoUrl: "logo-login-mm-v3.svg",
    compactLogoUrl: "logo-mm-mark.png",
    helpCenterUrl: MMHelpCenterUrl,
    supportWidget: {
      zendeskKey: MMZendeskKey,
      initZendeskWidget: mmWidgetInit,
    },
    favicon: "MessageMedia_favicon-v3.png",
  },
  vodanz: {
    brandCode: "vodanz",
    logoUrl: "logo-onenz.png",
    compactLogoUrl: "logo-onenz-collapsed.png",
    helpCenterUrl: "https://support.multitxt.co.nz",
    supportWidget: null,
    favicon: "multiTXT_favicon.png",
  },
  directSMS: {
    brandCode: "directSMS",
    logoUrl: "logo-directsms.svg",
    compactLogoUrl: "logo-directsms-collapsed.png",
    helpCenterUrl: MMHelpCenterUrl,
    supportWidget: {
      zendeskKey: MMZendeskKey,
      initZendeskWidget: mmWidgetInit,
    },
    favicon: "DirectSMS_favicon.png",
  },
  streetdata: {
    brandCode: "streetdata",
    logoUrl: "logo-streetdata.png",
    compactLogoUrl: "logo-streetdata-collapsed.png",
    helpCenterUrl: MMHelpCenterUrl,
    supportWidget: {
      zendeskKey: MMZendeskKey,
      initZendeskWidget: mmWidgetInit,
    },
    favicon: "StreetData_favicon.png",
  },
  wholesale: {
    brandCode: "wholesale",
    logoUrl: "logo-wholesale.svg",
    compactLogoUrl: "logo-wholesale-collapsed.png",
    helpCenterUrl: MMHelpCenterUrl,
    supportWidget: {
      zendeskKey: MMZendeskKey,
      initZendeskWidget: mmWidgetInit,
    },
    favicon: "WholesaleSMS_favicon.png",
  },
  "2degrees": {
    brandCode: "2degrees",
    logoUrl: "logo-2degrees.svg",
    compactLogoUrl: "logo-2degrees.svg",
    helpCenterUrl: "https://support.grouptext.2degrees.nz/",
    supportWidget: null,
    favicon: "2Degrees_favicon.png",
  },
  messagenet: {
    brandCode: "messagenet",
    logoUrl: "logo-messagenet.svg",
    compactLogoUrl: "logo-messagenet-collapsed.png",
    helpCenterUrl: MMHelpCenterUrl,
    supportWidget: {
      zendeskKey: MMZendeskKey,
      initZendeskWidget: mmWidgetInit,
    },
    favicon: "MessageNet_favicon.png",
  },
  mobipost: {
    brandCode: "mobipost",
    logoUrl: "logo-mobipost.svg",
    compactLogoUrl: "logo-mobipost-collapsed.png",
    helpCenterUrl: MMHelpCenterUrl,
    supportWidget: {
      zendeskKey: MMZendeskKey,
      initZendeskWidget: mmWidgetInit,
    },
    favicon: "Mobipost_favicon.png",
  },
  smscentral: {
    brandCode: "smscentral",
    logoUrl: "logo-smscentral.svg",
    compactLogoUrl: "logo-smscentral-collapsed.png",
    helpCenterUrl: MMHelpCenterUrl,
    supportWidget: {
      zendeskKey: MMZendeskKey,
      initZendeskWidget: mmWidgetInit,
    },
    favicon: "smscentral_favicon.png",
  },
  etxt: {
    brandCode: "etxt",
    logoUrl: "logo-etxt.svg",
    compactLogoUrl: "logo-etxt-collapsed.png",
    helpCenterUrl: "https://support.etxtservice.co.nz/",
    supportWidget: null,
    favicon: "eTxt_favicon.png",
  },
  simpletexting: {
    brandCode: "simpletexting",
    logoUrl: "logo-simpletexting.png",
    compactLogoUrl: "logo-simpletexting-collapsed.png",
    helpCenterUrl: "http://support.simpletexting.com/",
    supportWidget: null,
    favicon: "simpletexting_favicon.svg",
  },
  messagestudio: {
    brandCode: "messagestudio",
    logoUrl: "logo-login-messagestudio.svg",
    compactLogoUrl: "logo-messagestudio-collapsed.png",
    helpCenterUrl: MMHelpCenterUrl,
    supportWidget: null,
    favicon: "MessageStudio-favicon.png",
  },
  sincheu: {
    brandCode: "sincheu",
    logoUrl: "logo-login-sinch-engage.png",
    compactLogoUrl: "logo-sinch-engage-collapsed.png",
    helpCenterUrl: "https://support.app.sinch.com",
    supportWidget: {
      zendeskKey: EngageZendeskKey,
      initZendeskWidget: mmWidgetInit,
    },
    favicon: "SinchEngage_favicon.png",
  },
  "app-sinch": {
    brandCode: "app-sinch",
    logoUrl: "logo-login-sinch-engage.png",
    compactLogoUrl: "logo-sinch-engage-collapsed.png",
    helpCenterUrl: "https://support.app.sinch.com/hc/en-us",
    supportWidget: {
      zendeskKey: EngageZendeskKey,
      initZendeskWidget: mmWidgetInit,
    },
    favicon: "SinchEngage_favicon.png",
  },
  smsb: {
    brandCode: "smsb",
    logoUrl: "logo-smsb.jpg",
    compactLogoUrl: "logo-smsb-collapsed.png",
    helpCenterUrl: "https://support.smsbroadcast.com.au/",
    supportWidget: {
      zendeskKey: "b3d0b58b-cc88-4540-b718-b5ab4fdd3631",
      initZendeskWidget: smsbWidgetInit,
    },
    favicon: "SMSBroadcast_favicon.png",
  },
  tpgtelecom: {
    brandCode: "tpgtelecom",
    logoUrl: "logo-tpgtelecom.svg",
    compactLogoUrl: "logo-tpgtelecom-collapsed.png",
    helpCenterUrl: "http://support.messaging.tpgtelecom.com.au/",
    supportWidget: {
      zendeskKey: "bc043523-b8ba-429a-af95-2fbfb0e88b64",
      initZendeskWidget: tpgWidgetInit,
    },
    favicon: "TPGTelecom_favicon.png",
  },
  "notify-now": {
    brandCode: "notify-now",
    logoUrl: "logo-login-notify-now.png",
    compactLogoUrl: "notify-now-logo.png",
    helpCenterUrl: MMHelpCenterUrl,
    supportWidget: {
      zendeskKey: MMZendeskKey,
      initZendeskWidget: mmWidgetInit,
    },
    favicon: "notify_now-favicon.ico",
  },
});
